import React from 'react';
import { css, SerializedStyles } from '@emotion/react';

interface FullScreenProps extends React.HTMLProps<HTMLDivElement> {
  css?: SerializedStyles;
  filledHeight?: string;
}

export const FullScreen = React.forwardRef<HTMLDivElement, FullScreenProps>(
  ({ children, css: custom_css, filledHeight, ...otherProps }, ref) => {
    return (
      <div
        css={css`
          position: relative;
          width: 100%;
          height: 100vh;
          background: #fff;
          overflow-y: auto;
          ${custom_css}
        `}
        {...otherProps}
        ref={ref}
      >
        {children}
      </div>
    );
  },
);
